import { Stack } from "PFComponents/containers";
import { CustomValuePillProps } from "PFComponents/custom_value_pill/custom_value_pill";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "./custom_value_pill_tooltip.module.scss";
import { InlineIconText } from "./inline_icon_text";

type VerifiedIconsTooltipContentProps = Pick<
  CustomValuePillProps,
  "isVerified" | "isVerifiedCredly" | "isVerifiedOthers"
>;

export const VerifiedIconsTooltipContent = ({
  isVerified,
  isVerifiedCredly,
  isVerifiedOthers
}: VerifiedIconsTooltipContentProps) => {
  const { t } = useTranslation("core", { keyPrefix: "customValue" });

  return (
    <Stack>
      <Typography variant="labelRegular" className={css.tooltipColumnTitle}>
        {t("verified")}
      </Typography>
      {isVerified && (
        <InlineIconText
          iconName={isVerifiedCredly ? "verified-credly" : "verified"}
          text={isVerifiedCredly ? t("verifiedLabels.credly") : t("verifiedLabels.experience")}
        />
      )}
      {isVerifiedOthers && <InlineIconText iconName="verified-others" text={t("verifiedLabels.feedback")} />}
    </Stack>
  );
};
